import React, {useState} from "react";
import {useAuth} from "../../context/AuthContext";
import {useNavigate} from "react-router-dom";
import Login from "../auth/Login";
import AppProps from "../../static/js/AppProps";

const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return new Intl.DateTimeFormat('ru-RU', {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
    }).format(date);
};

const updateUserDetails = async (requestBody) => {
    return await fetch(`${AppProps.spring_server_url}/user`, {
        method: "PATCH",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify(requestBody),
    });
};

export default function UserDetails({user}) {
    const {logout} = useAuth();
    const navigate = useNavigate();

    const [fullName, setFullName] = useState(user?.full_name || "");
    const [email, setEmail] = useState(user?.email || "");
    const {register_date: registerDate} = user;
    const [isEditing, setIsEditing] = useState(false);

    const handleLogout = () => {
        logout();
        navigate(Login.link);
    };

    const handleSave = async () => {
        try {
            const response = await updateUserDetails({email, full_name: fullName});
            if (response.status === 200) {
                const {email, full_name: fullName} = await response.json();
                setEmail(email);
                setFullName(fullName);
                alert("Изменения сохранены!"); // TODO: notify
                setIsEditing(false);
            } else {
                const errorText = await response.text();
                alert(`Ошибка при обновлении: ${errorText}`); // TODO: notify
            }
        } catch (error) {
            console.error("Update error:", error); // TODO: notify
            alert("Произошла ошибка при сохранении изменений."); // TODO: notify
        }
    };

    return (
        <div className="container py-4">
            <div className="row justify-content-center">
                <div className="col-md-8">
                    <div className="card shadow-lg p-4">
                        <h3 className="text-primary display-5 text-center mb-4">
                            Профиль
                        </h3>

                        <div className="mb-3">
                            <div>
                                <label className="mbr-text mbr-fonts-style mb-4 display-7">Данные регистрации</label>
                                <p className="form-control-plaintext"><b>Имя пользователя: </b>{user.username}</p>
                                <p className="form-control-plaintext">
                                    <b>Зарегистрирован: </b>{formatDate(registerDate)}
                                </p>
                            </div>
                        </div>

                        <div className="mbr-text mbr-fonts-style mb-4 display-7">
                            <label className="mbr-text mbr-fonts-style mb-4 display-7">ФИО</label>
                            <input
                                type="text"
                                className="form-control"
                                value={fullName.toString()}
                                onChange={(e) => setFullName(e.target.value)}
                                readOnly={!isEditing}
                            />
                        </div>

                        <div className="mb-3">
                            <label className="mbr-text mbr-fonts-style mb-4 display-7">Email</label>
                            <input
                                type="email"
                                className="form-control"
                                value={email.toString()}
                                onChange={(e) => setEmail(e.target.value)}
                                readOnly={!isEditing}
                            />
                        </div>

                        <div className="d-flex justify-content-between mt-4">
                            {isEditing ? (
                                <button className="btn btn-success" onClick={handleSave}>
                                    Сохранить
                                </button>
                            ) : (
                                <button className="btn btn-secondary-outline"
                                        onClick={() => setIsEditing(true)}>
                                    Редактировать
                                </button>
                            )}
                            <button className="btn btn-info display-4" onClick={handleLogout}>
                                Выйти
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}